import { Request2Estes } from "../../../APIS";

const GET_SECTION = async (param) => {
  const payload = {
    parameters: param,
    target_data: "GET_SECTION",
  };
  const result = await Request2Estes(payload);

  return result;
};

const TYPE_LOOK_UP = async (param) => {
  const payload = {
    parameters: param,
    target_data: "TYPE_LOOK_UP",
  };
  const result = await Request2Estes(payload);

  return result;
};

const GET_SCR_COM = async (param) => {
  const payload = {
    parameters: param,
    target_data: "GET_SCR_COM",
  };
  const result = await Request2Estes(payload);

  return result;
};
const CREATE_APPEND_SECTION_COM = async (param) => {
  const payload = {
    parameters: param,
    target_data: "CREATE_APPEND_SECTION_COM",
  };
  const result = await Request2Estes(payload);

  return result;
};
const CREATE_APPEND_SECTION_COM2 = async (param) => {
  const payload = {
    parameters: param,
    target_data: "CREATE_APPEND_SECTION_COM2",
  };
  const result = await Request2Estes(payload);

  return result;
};


export {GET_SECTION, GET_SCR_COM, CREATE_APPEND_SECTION_COM, CREATE_APPEND_SECTION_COM2, TYPE_LOOK_UP}